import { useEffect, useState } from "react";

export type TimedProps = {
    delay: number; // How many seconds until element should appear
    enabled: boolean; // Whether the element should be enabled or not (on enable, will start timer from beginning)
    children?: React.ReactNode | undefined;
}

// This component will show the child element(s) after the given delay in seconds if enabled is true
export function Timed(props: TimedProps) {
	const [secondsElapsed, setSecondsElapsed] = useState<number | null>(null);


	useEffect(() => {
		if (secondsElapsed === null || secondsElapsed >= props.delay) {
			return;
		}

		const timer = setInterval(() => setSecondsElapsed(secondsElapsed + 1), 1000);
    	return () => clearInterval(timer);
	}, [secondsElapsed]);

    useEffect(() => {
        if (props.enabled === false) {
            // enabled has been triggered to false
            setSecondsElapsed(null);
        } else if (props.enabled) {
            setSecondsElapsed(0);
        }

    }, [props.enabled]);

    return (
        (props.enabled === true && secondsElapsed && secondsElapsed >= props.delay) ? 
            (props.children) : <></>
    );
}
